import createReactComponent from '../createReactComponent';
export default createReactComponent('outline', 'caret-up', 'IconCaretUp', [["path",{"d":"M18 14l-6 -6l-6 6h12","key":"svg-0"}]]);